/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "أمس",
        "-2": "أول أمس",
        "0": "اليوم",
        "1": "غدًا",
        "2": "بعد الغد",
        "future": {
          "few": "خلال {0} أيام",
          "many": "خلال {0} يومًا",
          "one": "خلال يوم واحد",
          "other": "خلال {0} يوم",
          "two": "خلال يومين",
          "zero": "خلال {0} يوم"
        },
        "past": {
          "few": "قبل {0} أيام",
          "many": "قبل {0} يومًا",
          "one": "قبل يوم واحد",
          "other": "قبل {0} يوم",
          "two": "قبل يومين",
          "zero": "قبل {0} يوم"
        }
      },
      "day-narrow": {
        "-1": "أمس",
        "-2": "أول أمس",
        "0": "اليوم",
        "1": "غدًا",
        "2": "بعد الغد",
        "future": {
          "few": "خلال {0} أيام",
          "many": "خلال {0} يومًا",
          "one": "خلال يوم واحد",
          "other": "خلال {0} يوم",
          "two": "خلال يومين",
          "zero": "خلال {0} يوم"
        },
        "past": {
          "few": "قبل {0} أيام",
          "many": "قبل {0} يومًا",
          "one": "قبل يوم واحد",
          "other": "قبل {0} يوم",
          "two": "قبل يومين",
          "zero": "قبل {0} يوم"
        }
      },
      "day-short": {
        "-1": "أمس",
        "-2": "أول أمس",
        "0": "اليوم",
        "1": "غدًا",
        "2": "بعد الغد",
        "future": {
          "few": "خلال {0} أيام",
          "many": "خلال {0} يومًا",
          "one": "خلال يوم واحد",
          "other": "خلال {0} يوم",
          "two": "خلال يومين",
          "zero": "خلال {0} يوم"
        },
        "past": {
          "few": "قبل {0} أيام",
          "many": "قبل {0} يومًا",
          "one": "قبل يوم واحد",
          "other": "قبل {0} يوم",
          "two": "قبل يومين",
          "zero": "قبل {0} يوم"
        }
      },
      "hour": {
        "0": "الساعة الحالية",
        "future": {
          "few": "خلال {0} ساعات",
          "many": "خلال {0} ساعة",
          "one": "خلال ساعة واحدة",
          "other": "خلال {0} ساعة",
          "two": "خلال ساعتين",
          "zero": "خلال {0} ساعة"
        },
        "past": {
          "few": "قبل {0} ساعات",
          "many": "قبل {0} ساعة",
          "one": "قبل ساعة واحدة",
          "other": "قبل {0} ساعة",
          "two": "قبل ساعتين",
          "zero": "قبل {0} ساعة"
        }
      },
      "hour-narrow": {
        "0": "الساعة الحالية",
        "future": {
          "few": "خلال {0} ساعات",
          "many": "خلال {0} ساعة",
          "one": "خلال ساعة واحدة",
          "other": "خلال {0} ساعة",
          "two": "خلال ساعتين",
          "zero": "خلال {0} ساعة"
        },
        "past": {
          "few": "قبل {0} ساعات",
          "many": "قبل {0} ساعة",
          "one": "قبل ساعة واحدة",
          "other": "قبل {0} ساعة",
          "two": "قبل ساعتين",
          "zero": "قبل {0} ساعة"
        }
      },
      "hour-short": {
        "0": "الساعة الحالية",
        "future": {
          "few": "خلال {0} ساعات",
          "many": "خلال {0} ساعة",
          "one": "خلال ساعة واحدة",
          "other": "خلال {0} ساعة",
          "two": "خلال ساعتين",
          "zero": "خلال {0} ساعة"
        },
        "past": {
          "few": "قبل {0} ساعات",
          "many": "قبل {0} ساعة",
          "one": "قبل ساعة واحدة",
          "other": "قبل {0} ساعة",
          "two": "قبل ساعتين",
          "zero": "قبل {0} ساعة"
        }
      },
      "minute": {
        "0": "هذه الدقيقة",
        "future": {
          "few": "خلال {0} دقائق",
          "many": "خلال {0} دقيقة",
          "one": "خلال دقيقة واحدة",
          "other": "خلال {0} دقيقة",
          "two": "خلال دقيقتين",
          "zero": "خلال {0} دقيقة"
        },
        "past": {
          "few": "قبل {0} دقائق",
          "many": "قبل {0} دقيقة",
          "one": "قبل دقيقة واحدة",
          "other": "قبل {0} دقيقة",
          "two": "قبل دقيقتين",
          "zero": "قبل {0} دقيقة"
        }
      },
      "minute-narrow": {
        "0": "هذه الدقيقة",
        "future": {
          "few": "خلال {0} دقائق",
          "many": "خلال {0} دقيقة",
          "one": "خلال دقيقة واحدة",
          "other": "خلال {0} دقيقة",
          "two": "خلال دقيقتين",
          "zero": "خلال {0} دقيقة"
        },
        "past": {
          "few": "قبل {0} دقائق",
          "many": "قبل {0} دقيقة",
          "one": "قبل دقيقة واحدة",
          "other": "قبل {0} دقيقة",
          "two": "قبل دقيقتين",
          "zero": "قبل {0} دقيقة"
        }
      },
      "minute-short": {
        "0": "هذه الدقيقة",
        "future": {
          "few": "خلال {0} دقائق",
          "many": "خلال {0} دقيقة",
          "one": "خلال دقيقة واحدة",
          "other": "خلال {0} دقيقة",
          "two": "خلال دقيقتين",
          "zero": "خلال {0} دقيقة"
        },
        "past": {
          "few": "قبل {0} دقائق",
          "many": "قبل {0} دقيقة",
          "one": "قبل دقيقة واحدة",
          "other": "قبل {0} دقيقة",
          "two": "قبل دقيقتين",
          "zero": "قبل {0} دقيقة"
        }
      },
      "month": {
        "-1": "الشهر الماضي",
        "0": "هذا الشهر",
        "1": "الشهر القادم",
        "future": {
          "few": "خلال {0} أشهر",
          "many": "خلال {0} شهرًا",
          "one": "خلال شهر واحد",
          "other": "خلال {0} شهر",
          "two": "خلال شهرين",
          "zero": "خلال {0} شهر"
        },
        "past": {
          "few": "قبل {0} أشهر",
          "many": "قبل {0} شهرًا",
          "one": "قبل شهر واحد",
          "other": "قبل {0} شهر",
          "two": "قبل شهرين",
          "zero": "قبل {0} شهر"
        }
      },
      "month-narrow": {
        "-1": "الشهر الماضي",
        "0": "هذا الشهر",
        "1": "الشهر القادم",
        "future": {
          "few": "خلال {0} أشهر",
          "many": "خلال {0} شهرًا",
          "one": "خلال شهر واحد",
          "other": "خلال {0} شهر",
          "two": "خلال شهرين",
          "zero": "خلال {0} شهر"
        },
        "past": {
          "few": "قبل {0} أشهر",
          "many": "قبل {0} شهرًا",
          "one": "قبل شهر واحد",
          "other": "قبل {0} شهر",
          "two": "قبل شهرين",
          "zero": "قبل {0} شهر"
        }
      },
      "month-short": {
        "-1": "الشهر الماضي",
        "0": "هذا الشهر",
        "1": "الشهر القادم",
        "future": {
          "few": "خلال {0} أشهر",
          "many": "خلال {0} شهرًا",
          "one": "خلال شهر واحد",
          "other": "خلال {0} شهر",
          "two": "خلال شهرين",
          "zero": "خلال {0} شهر"
        },
        "past": {
          "few": "خلال {0} أشهر",
          "many": "قبل {0} شهرًا",
          "one": "قبل شهر واحد",
          "other": "قبل {0} شهر",
          "two": "قبل شهرين",
          "zero": "قبل {0} شهر"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "الربع الأخير",
        "0": "هذا الربع",
        "1": "الربع القادم",
        "future": {
          "few": "خلال {0} أرباع سنة",
          "many": "خلال {0} ربع سنة",
          "one": "خلال ربع سنة واحد",
          "other": "خلال {0} ربع سنة",
          "two": "خلال ربعي سنة",
          "zero": "خلال {0} ربع سنة"
        },
        "past": {
          "few": "قبل {0} أرباع سنة",
          "many": "قبل {0} ربع سنة",
          "one": "قبل ربع سنة واحد",
          "other": "قبل {0} ربع سنة",
          "two": "قبل ربعي سنة",
          "zero": "قبل {0} ربع سنة"
        }
      },
      "quarter-narrow": {
        "-1": "الربع الأخير",
        "0": "هذا الربع",
        "1": "الربع القادم",
        "future": {
          "few": "خلال {0} أرباع سنة",
          "many": "خلال {0} ربع سنة",
          "one": "خلال ربع سنة واحد",
          "other": "خلال {0} ربع سنة",
          "two": "خلال ربعي سنة",
          "zero": "خلال {0} ربع سنة"
        },
        "past": {
          "few": "قبل {0} أرباع سنة",
          "many": "قبل {0} ربع سنة",
          "one": "قبل ربع سنة واحد",
          "other": "قبل {0} ربع سنة",
          "two": "قبل ربعي سنة",
          "zero": "قبل {0} ربع سنة"
        }
      },
      "quarter-short": {
        "-1": "الربع الأخير",
        "0": "هذا الربع",
        "1": "الربع القادم",
        "future": {
          "few": "خلال {0} أرباع سنة",
          "many": "خلال {0} ربع سنة",
          "one": "خلال ربع سنة واحد",
          "other": "خلال {0} ربع سنة",
          "two": "خلال ربعي سنة",
          "zero": "خلال {0} ربع سنة"
        },
        "past": {
          "few": "قبل {0} أرباع سنة",
          "many": "قبل {0} ربع سنة",
          "one": "قبل ربع سنة واحد",
          "other": "قبل {0} ربع سنة",
          "two": "قبل ربعي سنة",
          "zero": "قبل {0} ربع سنة"
        }
      },
      "second": {
        "0": "الآن",
        "future": {
          "few": "خلال {0} ثوانٍ",
          "many": "خلال {0} ثانية",
          "one": "خلال ثانية واحدة",
          "other": "خلال {0} ثانية",
          "two": "خلال ثانيتين",
          "zero": "خلال {0} ثانية"
        },
        "past": {
          "few": "قبل {0} ثوانِ",
          "many": "قبل {0} ثانية",
          "one": "قبل ثانية واحدة",
          "other": "قبل {0} ثانية",
          "two": "قبل ثانيتين",
          "zero": "قبل {0} ثانية"
        }
      },
      "second-narrow": {
        "0": "الآن",
        "future": {
          "few": "خلال {0} ثوانٍ",
          "many": "خلال {0} ثانية",
          "one": "خلال ثانية واحدة",
          "other": "خلال {0} ثانية",
          "two": "خلال ثانيتين",
          "zero": "خلال {0} ثانية"
        },
        "past": {
          "few": "قبل {0} ثوانٍ",
          "many": "قبل {0} ثانية",
          "one": "قبل ثانية واحدة",
          "other": "قبل {0} ثانية",
          "two": "قبل ثانيتين",
          "zero": "قبل {0} ثانية"
        }
      },
      "second-short": {
        "0": "الآن",
        "future": {
          "few": "خلال {0} ثوانٍ",
          "many": "خلال {0} ثانية",
          "one": "خلال ثانية واحدة",
          "other": "خلال {0} ثانية",
          "two": "خلال ثانيتين",
          "zero": "خلال {0} ثانية"
        },
        "past": {
          "few": "قبل {0} ثوانٍ",
          "many": "قبل {0} ثانية",
          "one": "قبل ثانية واحدة",
          "other": "قبل {0} ثانية",
          "two": "قبل ثانيتين",
          "zero": "قبل {0} ثانية"
        }
      },
      "week": {
        "-1": "الأسبوع الماضي",
        "0": "هذا الأسبوع",
        "1": "الأسبوع القادم",
        "future": {
          "few": "خلال {0} أسابيع",
          "many": "خلال {0} أسبوعًا",
          "one": "خلال أسبوع واحد",
          "other": "خلال {0} أسبوع",
          "two": "خلال أسبوعين",
          "zero": "خلال {0} أسبوع"
        },
        "past": {
          "few": "قبل {0} أسابيع",
          "many": "قبل {0} أسبوعًا",
          "one": "قبل أسبوع واحد",
          "other": "قبل {0} أسبوع",
          "two": "قبل أسبوعين",
          "zero": "قبل {0} أسبوع"
        }
      },
      "week-narrow": {
        "-1": "الأسبوع الماضي",
        "0": "هذا الأسبوع",
        "1": "الأسبوع القادم",
        "future": {
          "few": "خلال {0} أسابيع",
          "many": "خلال {0} أسبوعًا",
          "one": "خلال أسبوع واحد",
          "other": "خلال {0} أسبوع",
          "two": "خلال أسبوعين",
          "zero": "خلال {0} أسبوع"
        },
        "past": {
          "few": "قبل {0} أسابيع",
          "many": "قبل {0} أسبوعًا",
          "one": "قبل أسبوع واحد",
          "other": "قبل {0} أسبوع",
          "two": "قبل أسبوعين",
          "zero": "قبل {0} أسبوع"
        }
      },
      "week-short": {
        "-1": "الأسبوع الماضي",
        "0": "هذا الأسبوع",
        "1": "الأسبوع القادم",
        "future": {
          "few": "خلال {0} أسابيع",
          "many": "خلال {0} أسبوعًا",
          "one": "خلال أسبوع واحد",
          "other": "خلال {0} أسبوع",
          "two": "خلال {0} أسبوعين",
          "zero": "خلال {0} أسبوع"
        },
        "past": {
          "few": "قبل {0} أسابيع",
          "many": "قبل {0} أسبوعًا",
          "one": "قبل أسبوع واحد",
          "other": "قبل {0} أسبوع",
          "two": "قبل أسبوعين",
          "zero": "قبل {0} أسبوع"
        }
      },
      "year": {
        "-1": "السنة الماضية",
        "0": "السنة الحالية",
        "1": "السنة القادمة",
        "future": {
          "few": "خلال {0} سنوات",
          "many": "خلال {0} سنة",
          "one": "خلال سنة واحدة",
          "other": "خلال {0} سنة",
          "two": "خلال سنتين",
          "zero": "خلال {0} سنة"
        },
        "past": {
          "few": "قبل {0} سنوات",
          "many": "قبل {0} سنة",
          "one": "قبل سنة واحدة",
          "other": "قبل {0} سنة",
          "two": "قبل سنتين",
          "zero": "قبل {0} سنة"
        }
      },
      "year-narrow": {
        "-1": "السنة الماضية",
        "0": "السنة الحالية",
        "1": "السنة القادمة",
        "future": {
          "few": "خلال {0} سنوات",
          "many": "خلال {0} سنة",
          "one": "خلال سنة واحدة",
          "other": "خلال {0} سنة",
          "two": "خلال سنتين",
          "zero": "خلال {0} سنة"
        },
        "past": {
          "few": "قبل {0} سنوات",
          "many": "قبل {0} سنة",
          "one": "قبل سنة واحدة",
          "other": "قبل {0} سنة",
          "two": "قبل سنتين",
          "zero": "قبل {0} سنة"
        }
      },
      "year-short": {
        "-1": "السنة الماضية",
        "0": "السنة الحالية",
        "1": "السنة القادمة",
        "future": {
          "few": "خلال {0} سنوات",
          "many": "خلال {0} سنة",
          "one": "خلال سنة واحدة",
          "other": "خلال {0} سنة",
          "two": "خلال سنتين",
          "zero": "خلال {0} سنة"
        },
        "past": {
          "few": "قبل {0} سنوات",
          "many": "قبل {0} سنة",
          "one": "قبل سنة واحدة",
          "other": "قبل {0} سنة",
          "two": "قبل سنتين",
          "zero": "قبل {0} سنة"
        }
      }
    },
    "locale": "ar-TN"
  });
}